// Colores sugeridos por el contrato: excelente verde, buena verde claro,
// regular amarillo, mala rojo, sin calificar gris.
export const NIVEL_COLORS = {
    excelente: { color: '#047857', bg: '#D1FAE5', solid: '#10B981' },
    buena: { color: '#4D7C0F', bg: '#ECFCCB', solid: '#84CC16' },
    regular: { color: '#B45309', bg: '#FEF3C7', solid: '#F59E0B' },
    mala: { color: '#B91C1C', bg: '#FEE2E2', solid: '#EF4444' },
    sin: { color: '#64748B', bg: '#F1F5F9', solid: '#94A3B8' },
};

export const nivelStyle = (nivel) => {
    const c = NIVEL_COLORS[nivel?.clave] || NIVEL_COLORS.sin;
    return { color: c.color, background: c.bg };
};

export const nivelSolid = (clave) => (NIVEL_COLORS[clave] || NIVEL_COLORS.sin).solid;

export const nivelNombre = (nivel) => nivel?.nombre || 'Sin calificar';

// Color de una barra de 1 a 5 según el mismo corte de los niveles
export const colorPorPromedio = (valor) => {
    if (valor === null || valor === undefined) return NIVEL_COLORS.sin.solid;
    if (valor >= 4.5) return NIVEL_COLORS.excelente.solid;
    if (valor >= 4) return NIVEL_COLORS.buena.solid;
    if (valor >= 3) return NIVEL_COLORS.regular.solid;
    return NIVEL_COLORS.mala.solid;
};

export const formatPromedio = (valor) =>
    valor === null || valor === undefined ? '—' : Number(valor).toFixed(1);

export const formatNumber = (valor) => Number(valor || 0).toLocaleString('es-CO');

export const formatPorcentaje = (valor) =>
    valor === null || valor === undefined ? '—' : `${Number(valor).toLocaleString('es-CO', { maximumFractionDigits: 1 })}%`;

// Variación con signo: "+0.2" / "−0.1"
export const formatVariacion = (valor, sufijo = '') => {
    if (valor === null || valor === undefined) return '—';
    const num = Number(valor);
    const signo = num > 0 ? '+' : num < 0 ? '−' : '';
    return `${signo}${Math.abs(num).toLocaleString('es-CO', { maximumFractionDigits: 1 })}${sufijo}`;
};

export const variacionIcon = (valor) => {
    if (valor === null || valor === undefined || Number(valor) === 0) return 'fas fa-minus';
    return Number(valor) > 0 ? 'fas fa-caret-up' : 'fas fa-caret-down';
};

export const variacionClass = (valor) => {
    if (valor === null || valor === undefined || Number(valor) === 0) return 'var-neutra';
    return Number(valor) > 0 ? 'var-sube' : 'var-baja';
};

// Las fechas llegan en ISO 8601 con zona; se muestran en hora local
export const formatFechaHora = (iso) => {
    if (!iso) return '—';
    const d = new Date(iso);
    if (isNaN(d)) return iso;
    return d.toLocaleString('es-CO', {
        day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
    });
};

export const formatFecha = (fecha) => {
    if (!fecha) return '';
    const [y, m, d] = String(fecha).slice(0, 10).split('-');
    return `${d}/${m}/${y}`;
};

// Error de la API: { success:false, data, errorMessage, status }.
// En el 422 los detalles vienen en data.errors. Con responseType 'blob'
// (exportar) el cuerpo llega como Blob y hay que leerlo primero.
export const mensajeError = async (error, porDefecto = 'Ocurrió un error inesperado.') => {
    let body = error?.response?.data;

    if (body instanceof Blob) {
        try {
            body = JSON.parse(await body.text());
        } catch (e) {
            body = null;
        }
    }

    const errores = body?.data?.errors;
    if (errores && typeof errores === 'object') {
        const primero = Object.values(errores).flat()[0];
        if (primero) return primero;
    }

    if (typeof body?.errorMessage === 'string' && body.errorMessage) return body.errorMessage;
    if (typeof body?.message === 'string' && body.message) return body.message;
    return porDefecto;
};
